import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "./utils";
function Card({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card", className: cn("bg-white text-card-foreground flex flex-col gap-6 rounded-xl border border-gray-200 shadow-sm", className), ...props }));
}
function CardHeader({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-header", className: cn("@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 pt-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6", className), ...props }));
}
function CardTitle({ className, ...props }) {
    return (_jsx("h4", { "data-slot": "card-title", className: cn("leading-none", className), ...props }));
}
function CardDescription({ className, ...props }) {
    return (_jsx("p", { "data-slot": "card-description", className: cn("text-muted-foreground", className), ...props }));
}
function CardAction({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-action", className: cn("col-start-2 row-span-2 row-start-1 self-start justify-self-end", className), ...props }));
}
function CardContent({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-content", className: cn("px-6 [&:last-child]:pb-6", className), ...props }));
}
function CardFooter({ className, ...props }) {
    return (_jsx("div", { "data-slot": "card-footer", className: cn("flex items-center px-6 pb-6 [.border-t]:pt-6", className), ...props }));
}
export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent, };
